import { Features, JoinWaitingList, Landing } from 'features/misc';
import { useAuth } from 'lib/auth';
import { useNavigate, useRoutes } from 'react-router-dom';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const auth = useAuth();

  const navigate = useNavigate();

  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/features', element: <Features /> },
    { path: '/join-waiting-list', element: <JoinWaitingList /> },
  ];

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
